import type { Drama } from '@/types/drama';

export const dramas: Drama[] = [
  {
    id: '1001',
    title: '都市之光',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20TV%20drama%20poster%2C%20modern%20metropolitan%20cityscape%20at%20dusk%20with%20glowing%20skyscrapers%2C%20elegant%20business%20silhouette%2C%20rich%20teal%20and%20amber%20color%20grading%2C%20dramatic%20lighting%2C%20premium%20streaming%20cover%20art%2C%20high%20detail%2C%20minimalist%20composition&width=400&height=600&seq=poster-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20futuristic%20metropolitan%20skyline%20at%20night%20with%20warm%20golden%20window%20lights%2C%20deep%20teal%20and%20amber%20tones%2C%20atmospheric%20fog%2C%20premium%20drama%20key%20art%2C%20high%20detail%2C%20dramatic%20composition&width=1600&height=900&seq=hero-01&orientation=landscape',
    types: ['都市', '爱情'],
    region: '中国大陆',
    year: 2025,
    status: '连载中',
    totalEpisodes: 40,
    currentEpisodes: 28,
    actors: ['林知遥', '程亦辰', '苏晚晴'],
    director: '陈默',
    synopsis: '在霓虹闪烁的都市森林里，三位背景迥异的年轻人因为一次偶然的创业计划走到一起。他们在资本博弈与情感纠葛中，寻找属于自己的光。每一次跌倒与重新站起，都让他们离梦想更近一步。',
    hot: 9820,
    premiereDate: '2026-07-12',
    updatedAt: '2026-10-11',
  },
  {
    id: '1002',
    title: '锦绣长歌',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20Chinese%20historical%20drama%20poster%2C%20elegant%20figure%20in%20flowing%20silk%20hanfu%20before%20an%20ancient%20palace%2C%20teal%20and%20gold%20color%20grading%2C%20soft%20misty%20lighting%2C%20ornate%20lanterns%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20grand%20ancient%20imperial%20palace%20courtyard%20at%20golden%20hour%2C%20red%20lanterns%20and%20green%20pine%20trees%2C%20misty%20mountains%20behind%2C%20warm%20gold%20and%20jade%20tones%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-02&orientation=landscape',
    types: ['古装', '爱情'],
    region: '中国大陆',
    year: 2025,
    status: '连载中',
    totalEpisodes: 56,
    currentEpisodes: 40,
    actors: ['沈清欢', '顾长风', '赵灵儿'],
    director: '韩雪松',
    synopsis: '乱世之中，一介孤女凭借过人智慧踏入深宫。她以仁心化解权谋，用真情守护一方安宁。当江山与私情相冲突，她必须在锦绣长歌中写下自己的抉择。',
    hot: 9610,
    premiereDate: '2026-06-28',
    updatedAt: '2026-10-10',
  },
  {
    id: '1003',
    title: '迷雾追凶',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20suspense%20crime%20drama%20poster%2C%20lone%20detective%20silhouette%20in%20rainy%20alley%20with%20cold%20street%20lamps%2C%20deep%20green%20and%20amber%20grading%2C%20moody%20shadows%2C%20mysterious%20atmosphere%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20foggy%20night%20city%20street%20with%20wet%20asphalt%20reflections%20and%20dim%20streetlights%2C%20dark%20green%20and%20amber%20tones%2C%20tense%20thriller%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-03&orientation=landscape',
    types: ['悬疑', '动作'],
    region: '中国大陆',
    year: 2025,
    status: '已完结',
    totalEpisodes: 24,
    currentEpisodes: 24,
    actors: ['江砚', '陆雨薇', '周牧言'],
    director: '高远',
    synopsis: '一桩尘封十年的旧案重新浮出水面，年轻刑警与经验老到的法医联手追查真相。迷雾之下，每个看似无关的细节都指向同一个答案。',
    hot: 9455,
    premiereDate: '2026-05-16',
    updatedAt: '2026-10-09',
  },
  {
    id: '1004',
    title: '心动信号',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20Korean%20romance%20drama%20poster%2C%20couple%20under%20warm%20string%20lights%20at%20a%20cozy%20cafe%2C%20soft%20pink%20and%20mint%20tones%2C%20dreamy%20bokeh%20lighting%2C%20gentle%20romantic%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20cozy%20evening%20cafe%20terrace%20filled%20with%20warm%20string%20lights%2C%20blurred%20city%20background%2C%20soft%20pink%20and%20mint%20tones%2C%20romantic%20warm%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-04&orientation=landscape',
    types: ['爱情', '都市'],
    region: '韩国',
    year: 2025,
    status: '连载中',
    totalEpisodes: 16,
    currentEpisodes: 12,
    actors: ['金秀贤', '朴敏英', '宋江'],
    director: '李承佑',
    synopsis: '一档恋爱观察节目让原本毫无交集的两个人相遇。镜头之外的真心，能否穿过层层误会抵达对方心里？这是一场关于勇气与心动信号的温柔故事。',
    hot: 9310,
    premiereDate: '2026-08-01',
    updatedAt: '2026-10-11',
  },
  {
    id: '1005',
    title: '星际纪元',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20science%20fiction%20space%20drama%20poster%2C%20astronaut%20before%20a%20giant%20glowing%20planet%2C%20deep%20teal%20and%20violet%20nebula%20tones%2C%20epic%20cosmic%20lighting%2C%20futuristic%20sci-fi%20atmosphere%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20vast%20space%20station%20orbiting%20a%20glowing%20ringed%20planet%2C%20deep%20teal%20and%20emerald%20nebula%20tones%2C%20epic%20sci-fi%20lighting%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-05&orientation=landscape',
    types: ['科幻', '动作'],
    region: '美国',
    year: 2024,
    status: '已完结',
    totalEpisodes: 20,
    currentEpisodes: 20,
    actors: ['Ethan Cole', 'Mia Turner', 'Noah Reed'],
    director: 'Robert King',
    synopsis: '人类首次踏足遥远星系，一支科考队在未知星球上发现了颠覆认知的信号。当科技与信仰碰撞，他们必须决定人类文明的下一个方向。',
    hot: 9180,
    premiereDate: '2026-03-20',
    updatedAt: '2026-10-05',
  },
  {
    id: '1006',
    title: '温暖的家',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20family%20drama%20poster%2C%20three%20generations%20gathered%20in%20a%20sunlit%20warm%20living%20room%2C%20soft%20green%20and%20cream%20tones%2C%20cozy%20natural%20lighting%2C%20heartwarming%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20warm%20sunlit%20family%20home%20with%20open%20windows%20and%20green%20garden%2C%20soft%20cream%20and%20sage%20tones%2C%20heartwarming%20cozy%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-06&orientation=landscape',
    types: ['家庭', '都市'],
    region: '中国大陆',
    year: 2024,
    status: '已完结',
    totalEpisodes: 36,
    currentEpisodes: 36,
    actors: ['王秀兰', '李建国', '孙悦'],
    director: '张丽',
    synopsis: '三代同堂的普通人家，在柴米油盐中磨合出最深的羁绊。当生活的风浪袭来，是这个家给了每个人继续前行的勇气。',
    hot: 8760,
    premiereDate: '2026-01-08',
    updatedAt: '2026-09-28',
  },
  {
    id: '1007',
    title: '暗夜特工',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20action%20spy%20drama%20poster%2C%20agent%20silhouette%20in%20dark%20trench%20coat%20with%20dramatic%20rim%20light%2C%20teal%20and%20amber%20tones%2C%20high%20contrast%20shadows%2C%20tense%20espionage%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20dramatic%20nighttime%20rooftop%20scene%20with%20a%20lone%20agent%20silhouette%20against%20city%20lights%2C%20teal%20and%20amber%20tones%2C%20tense%20action%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-07&orientation=landscape',
    types: ['动作', '悬疑'],
    region: '美国',
    year: 2025,
    status: '连载中',
    totalEpisodes: 12,
    currentEpisodes: 8,
    actors: ['Ryan Blake', 'Zoe Carter', 'Liam Fox'],
    director: 'Michael Dean',
    synopsis: '一名隐退多年的特工被迫重返战场，只为守护一个深藏多年的秘密。在信任与背叛的边缘，他必须做出最艰难的选择。',
    hot: 8990,
    premiereDate: '2026-08-22',
    updatedAt: '2026-10-11',
  },
  {
    id: '1008',
    title: '欢乐一家亲',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20comedy%20drama%20poster%2C%20cheerful%20group%20of%20friends%20laughing%20in%20a%20bright%20colorful%20apartment%2C%20warm%20green%20and%20orange%20tones%2C%20playful%20airy%20lighting%2C%20joyful%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20bright%20playful%20living%20room%20party%20with%20colorful%20balloons%20and%20cozy%20furniture%2C%20warm%20green%20and%20orange%20tones%2C%20joyful%20upbeat%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-08&orientation=landscape',
    types: ['喜剧', '家庭'],
    region: '中国大陆',
    year: 2024,
    status: '已完结',
    totalEpisodes: 30,
    currentEpisodes: 30,
    actors: ['郭晓东', '马丽', '常远'],
    director: '冯超',
    synopsis: '一家三代人挤在同一屋檐下，鸡飞狗跳的日常里全是笑声。平凡的小事被他们过成了最热闹的喜剧。',
    hot: 8520,
    premiereDate: '2026-02-14',
    updatedAt: '2026-09-20',
  },
  {
    id: '1009',
    title: '大汉风云',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20epic%20historical%20war%20drama%20poster%2C%20armored%20general%20on%20horseback%20before%20a%20vast%20battlefield%2C%20deep%20green%20and%20gold%20tones%2C%20dramatic%20dust%20lighting%2C%20grand%20historical%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20grand%20ancient%20battlefield%20with%20marching%20armies%20and%20banners%20at%20sunrise%2C%20deep%20green%20and%20gold%20tones%2C%20epic%20historical%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-09&orientation=landscape',
    types: ['历史', '古装'],
    region: '中国大陆',
    year: 2023,
    status: '已完结',
    totalEpisodes: 48,
    currentEpisodes: 48,
    actors: ['张丰毅', '陈道明', '许晴'],
    director: '胡玫',
    synopsis: '一个大一统王朝的崛起，背后是无数人的热血与牺牲。权谋、征伐、理想与妥协，在历史的洪流中交织成一幅壮阔画卷。',
    hot: 8430,
    premiereDate: '2025-11-05',
    updatedAt: '2026-09-15',
  },
  {
    id: '1010',
    title: '职场风云',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20workplace%20drama%20poster%2C%20confident%20young%20professionals%20in%20a%20glass%20office%20tower%2C%20cool%20green%20and%20amber%20tones%2C%20clean%20modern%20lighting%2C%20ambitious%20corporate%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20modern%20glass%20office%20interior%20at%20dusk%20with%20city%20views%2C%20cool%20green%20and%20amber%20tones%2C%20clean%20corporate%20atmosphere%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-10&orientation=landscape',
    types: ['都市'],
    region: '中国大陆',
    year: 2025,
    status: '连载中',
    totalEpisodes: 32,
    currentEpisodes: 18,
    actors: ['杨幂', '王凯', '江疏影'],
    director: '李木戈',
    synopsis: '初入职场的她凭实力一路闯关，在明争暗斗的写字楼里站稳脚跟。升职与底线之间，她选择了一条更难走却更值得的路。',
    hot: 9120,
    premiereDate: '2026-07-25',
    updatedAt: '2026-10-11',
  },
  {
    id: '1011',
    title: '一代女相',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20ancient%20court%20drama%20poster%2C%20elegant%20female%20official%20in%20ornate%20robe%20before%20imperial%20throne%2C%20jade%20green%20and%20gold%20tones%2C%20soft%20candlelight%2C%20regal%20atmosphere%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20an%20ornate%20ancient%20throne%20hall%20lit%20by%20rows%20of%20candles%2C%20jade%20green%20and%20gold%20tones%2C%20regal%20solemn%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-11&orientation=landscape',
    types: ['古装', '历史'],
    region: '中国大陆',
    year: 2024,
    status: '已完结',
    totalEpisodes: 45,
    currentEpisodes: 45,
    actors: ['赵丽颖', '冯绍峰', '朱一龙'],
    director: '张开宙',
    synopsis: '从民间女子到一代女相，她以非凡的胆识辅佐明君、改革弊政。在男权林立的朝堂上，她用能力赢得了所有人的尊重。',
    hot: 8890,
    premiereDate: '2026-03-02',
    updatedAt: '2026-09-30',
  },
  {
    id: '1012',
    title: '无声证词',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20crime%20investigation%20drama%20poster%2C%20forensic%20detective%20examining%20evidence%20under%20cold%20light%2C%20deep%20green%20and%20amber%20tones%2C%20clinical%20suspense%20lighting%2C%20mysterious%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20dim%20forensic%20laboratory%20with%20glowing%20screens%20and%20evidence%20tables%2C%20deep%20green%20and%20amber%20tones%2C%20clinical%20suspense%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-12&orientation=landscape',
    types: ['悬疑'],
    region: '中国香港',
    year: 2024,
    status: '已完结',
    totalEpisodes: 22,
    currentEpisodes: 22,
    actors: ['古天乐', '佘诗曼', '林家栋'],
    director: '杜琪峰',
    synopsis: '尸体不会说话，但证据会。一位执着的法医与一位固执的警探，从蛛丝马迹中拼凑出被刻意掩盖的真相。',
    hot: 8680,
    premiereDate: '2026-02-20',
    updatedAt: '2026-09-25',
  },
  {
    id: '1013',
    title: '时光恋人',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20time%20travel%20romance%20drama%20poster%2C%20couple%20reaching%20toward%20each%20other%20with%20glowing%20clock%20light%20between%20them%2C%20soft%20green%20and%20rose%20tones%2C%20dreamy%20ethereal%20lighting%2C%20romantic%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-13&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20dreamy%20starscape%20with%20glowing%20clocks%20and%20silhouettes%20of%20a%20couple%2C%20soft%20green%20and%20rose%20tones%2C%20ethereal%20romantic%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-13&orientation=landscape',
    types: ['爱情', '科幻'],
    region: '中国大陆',
    year: 2025,
    status: '连载中',
    totalEpisodes: 24,
    currentEpisodes: 14,
    actors: ['迪丽热巴', '任嘉伦'],
    director: '尹涛',
    synopsis: '一次意外让她获得了回到过去的能力，却只能在有限的时间里改变一个瞬间。为了留住最重要的人，她一次次穿越时光，只为改写那个结局。',
    hot: 9050,
    premiereDate: '2026-08-10',
    updatedAt: '2026-10-11',
  },
  {
    id: '1014',
    title: '未来之城',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20cyberpunk%20city%20drama%20poster%2C%20lone%20figure%20before%20a%20neon%20smart%20city%20with%20holographic%20signs%2C%20emerald%20and%20amber%20tones%2C%20futuristic%20glow%2C%20high%20tech%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-14&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20futuristic%20neon%20smart%20city%20skyline%20with%20holographic%20displays%20and%20flying%20vehicles%2C%20emerald%20and%20amber%20tones%2C%20high%20tech%20atmosphere%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-14&orientation=landscape',
    types: ['科幻', '悬疑'],
    region: '日本',
    year: 2024,
    status: '已完结',
    totalEpisodes: 18,
    currentEpisodes: 18,
    actors: ['山崎贤人', '新垣结衣', '菅田将晖'],
    director: '庵野秀明',
    synopsis: '在一座由人工智能管理的未来都市里，一场数据异常引发连锁危机。一位普通程序员被卷入其中，逐渐揭开城市背后的惊人秘密。',
    hot: 8340,
    premiereDate: '2026-04-18',
    updatedAt: '2026-09-12',
  },
  {
    id: '1015',
    title: '幸福来敲门',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20warm%20slice%20of%20life%20drama%20poster%2C%20mother%20and%20child%20walking%20home%20on%20a%20tree%20lined%20street%2C%20soft%20green%20and%20cream%20tones%2C%20gentle%20golden%20hour%20lighting%2C%20uplifting%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-15&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20peaceful%20tree%20lined%20suburban%20street%20at%20golden%20hour%20with%20warm%20home%20windows%2C%20soft%20green%20and%20cream%20tones%2C%20uplifting%20warm%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-15&orientation=landscape',
    types: ['家庭'],
    region: '中国大陆',
    year: 2023,
    status: '已完结',
    totalEpisodes: 40,
    currentEpisodes: 40,
    actors: ['闫妮', '张嘉译', '海清'],
    director: '汪俊',
    synopsis: '一个单亲妈妈带着孩子在大城市打拼，生活虽苦却从未放弃希望。当善意一次次降临，她终于相信幸福真的会来敲门。',
    hot: 8210,
    premiereDate: '2025-10-12',
    updatedAt: '2026-09-08',
  },
  {
    id: '1016',
    title: '青春不散场',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20youth%20campus%20drama%20poster%2C%20group%20of%20students%20running%20on%20a%20sunny%20campus%20track%2C%20fresh%20green%20and%20sky%20tones%2C%20bright%20energetic%20lighting%2C%20youthful%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-16&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20sunny%20green%20university%20campus%20with%20students%20walking%20along%20tree%20lined%20paths%2C%20fresh%20green%20and%20warm%20tones%2C%20youthful%20energetic%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-16&orientation=landscape',
    types: ['都市', '爱情'],
    region: '中国大陆',
    year: 2024,
    status: '已完结',
    totalEpisodes: 28,
    currentEpisodes: 28,
    actors: ['白鹿', '王一博', '张新成'],
    director: '郭虎',
    synopsis: '大学四年，一群性格各异的年轻人从陌生到挚友。毕业那天的约定，成为他们此后人生里最温柔的注脚。青春会散场，但故事不会。',
    hot: 8560,
    premiereDate: '2026-01-20',
    updatedAt: '2026-09-22',
  },
  {
    id: '1017',
    title: '江湖行',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20wuxia%20martial%20arts%20drama%20poster%2C%20young%20swordsman%20standing%20beneath%20bamboo%20forest%20with%20drifting%20leaves%2C%20jade%20green%20and%20gold%20tones%2C%20misty%20ethereal%20lighting%2C%20heroic%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-17&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20misty%20bamboo%20forest%20with%20a%20lone%20swordsman%20silhouette%20on%20a%20rock%2C%20jade%20green%20and%20gold%20tones%2C%20ethereal%20martial%20arts%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-17&orientation=landscape',
    types: ['古装', '动作'],
    region: '中国大陆',
    year: 2025,
    status: '连载中',
    totalEpisodes: 50,
    currentEpisodes: 33,
    actors: ['王俊凯', '易烊千玺', '周也'],
    director: '尹力',
    synopsis: '少年自小山村走出，只为查明师门变故的真相。一路行侠仗义，也一路看清江湖的恩怨与情义。江湖路远，唯剑与心不可负。',
    hot: 9290,
    premiereDate: '2026-06-15',
    updatedAt: '2026-10-11',
  },
  {
    id: '1018',
    title: '真相边缘',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20Korean%20thriller%20drama%20poster%2C%20tense%20man%20looking%20over%20shoulder%20in%20a%20dim%20corridor%2C%20deep%20green%20and%20amber%20tones%2C%20high%20contrast%20shadow%20lighting%2C%20nail%20biting%20mood%2C%20premium%20streaming%20cover%20art%2C%20high%20detail&width=400&height=600&seq=poster-18&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20of%20a%20dim%20narrow%20corridor%20with%20a%20single%20glowing%20door%20at%20the%20end%2C%20deep%20green%20and%20amber%20tones%2C%20tense%20thriller%20mood%2C%20premium%20drama%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-18&orientation=landscape',
    types: ['悬疑', '都市'],
    region: '韩国',
    year: 2025,
    status: '连载中',
    totalEpisodes: 14,
    currentEpisodes: 9,
    actors: ['李栋旭', '徐睿知', '金材昱'],
    director: '金成勋',
    synopsis: '一名记者在追查一桩旧案时，发现真相远比想象中复杂。当所有人都劝他收手，他却在真相的边缘越走越近，也越来越危险。',
    hot: 8940,
    premiereDate: '2026-08-05',
    updatedAt: '2026-10-11',
  },
];

export const allTypes: string[] = ['都市', '古装', '悬疑', '爱情', '科幻', '家庭', '动作', '喜剧', '历史'];